<script>
import baseMixin from '@/mixins/baseMixin'
import CreateLoginDialogAndButton from '@components/candidate/login/create-login-dialog-and-button.vue'
import UpdateEmailDialogAndButton from '@components/candidate/login/update-email-dialog-and-button.vue'
import RemoveLoginDialogAndButton from '@components/candidate/login/remove-login-dialog-and-button.vue'
import ResetPasswordDialogAndButton from '@components/candidate/login/reset-password-dialog-and-button.vue'
import dayjs from '@services/date'
import config from '@/common/config'

export default {
  name: 'UserManagementContainer',
  components: {
    CreateLoginDialogAndButton,
    UpdateEmailDialogAndButton,
    RemoveLoginDialogAndButton,
    ResetPasswordDialogAndButton,
  },
  mixins: [baseMixin],
  props: {
    userDetails: {
      type: Object,
      required: true,
    },
    candidateId: {
      type: Number,
      required: true,
    },
  },
  data: () => {
    return {
      ready2WorkImpersonatePath: config.get('ready2work.impersonatePath'),
    }
  },
  computed: {
    compHasLinkToR2WUser() {
      return this.userDetails.hasLinkToR2WUser
    },
    compHasDifferentUserEmail() {
      return this.userDetails.hasEmailMismatch
    },
    compCandidateName() {
      const name = `${this.userDetails.firstName} ${this.userDetails.lastName}`
      return name.trim()
    },
    compCandidateEmail() {
      return this.userDetails.candidateEmail
    },
    compLastSeen() {
      if (this.userDetails.lastLoggedInUTC) {
        const timeFrom = dayjs(this.userDetails.lastLoggedInUTC).fromNow()
        return this.$t('candidate.lastSeenText', {
          candidateName: this.compCandidateName,
          timeFrom,
        })
      }
      return this.$t('candidate.hasNotLoggedInText', {
        candidateName: this.compCandidateName,
      })
    },
    compImpersonateLink() {
      return `${this.ready2WorkImpersonatePath}${this.candidateId}`
    },
  },
}
</script>

<template>
  <section>
    <v-alert
      v-if="compHasDifferentUserEmail"
      class="text-body-2 user-management-container__different-user-email-alert"
      dense
      text
      type="error"
      border="left"
    >
      {{
        $t('candidate.hasDifferentLoginEmailText', {
          userEmail: userDetails.userEmail,
        })
      }}
    </v-alert>
    <v-alert
      v-else-if="compHasLinkToR2WUser"
      class="text-body-2 user-management-container__has-link-alert"
      dense
      text
      type="info"
      border="left"
    >
      {{ $t('candidate.hasLoginText') }}
    </v-alert>

    <v-alert
      v-else
      class="text-body-2 user-management-container__no-link-alert"
      dense
      text
      type="warning"
      border="left"
    >
      {{ $t('candidate.doesNotHaveLoginText') }}
    </v-alert>
    <p
      v-if="compHasLinkToR2WUser"
      class="user-management-container__last-logged-in"
      >{{ compLastSeen }}</p
    >
    <v-card-actions class="justify-end pa-0">
      <CreateLoginDialogAndButton
        v-if="!compHasLinkToR2WUser"
        :candidate-id="candidateId"
        :candidate-name="compCandidateName"
        @login-created="$emit('login-created')"
      />
      <RemoveLoginDialogAndButton
        v-if="compHasLinkToR2WUser && !compHasDifferentUserEmail"
        :candidate-id="candidateId"
        :candidate-name="compCandidateName"
        @login-removed="$emit('login-removed')"
      />
      <UpdateEmailDialogAndButton
        v-if="compHasDifferentUserEmail"
        :candidate-id="candidateId"
        :candidate-name="compCandidateName"
        :candidate-email="compCandidateEmail"
        @login-email-synchronised="$emit('login-email-synchronised')"
      />
      <ResetPasswordDialogAndButton
        v-if="compHasLinkToR2WUser && !compHasDifferentUserEmail"
        :candidate-id="candidateId"
        :candidate-name="compCandidateName"
      />
      <v-btn
        v-if="compHasLinkToR2WUser && !compHasDifferentUserEmail"
        id="reset-password-button"
        color="primary"
        :href="compImpersonateLink"
        target="blank"
        >{{ $t('general.impersonateBtnLabel') }}</v-btn
      >
    </v-card-actions>
  </section>
</template>
